export const SECURE_TOKEN_STORAGE_KEY = 'lsAccountsJwtToken';
export const KEEP_ME_SIGNED_IN_KEY = 'lsKeepMeSignedIn';
export const DEVICE_UUID_KEY = 'lsDeviceUuid';
